module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"main-msg":"Dubizzle Group IPO","btn-text":"More Info","btn-link":"/investing/services/ipo-subscriptions/dubizzle","btn-text2":"More Info","btn-link2":"https://ipo.dubizzlegroup.com"},"ar":{"main-msg":"الطرح العام الأولي مجموعة دوبيزل","btn-text":"المزيد","btn-link":"/investing/services/ipo-subscriptions/dubizzle","btn-text2":"المزيد","btn-link2":"https://ipo.dubizzlegroup.com"}}')
  delete Component.options._Ctor
}
